import React, { useEffect } from "react";
import moment from "moment/min/moment-with-locales";
import { Redirect } from "react-router-dom";
import { breakLine } from "../../utils";

moment.locale("pl");

const EventDetailScreen = ({ location }) => {
  useEffect(() => {
    if (!location.event) return;
    document.title = location.event.title;
  }, [location]);
  if (!location.event) return <Redirect to="/" />;
  const { event } = location;
  return (
    <div className="container main-container mb-3 mt-3">
      <div className="row mt-1">
        <div className="col-md-12">
          <h5>{event.title}</h5>
          <p className="small text-muted">
            {moment(event.date.seconds * 1000).format("DD MMMM")}
          </p>
          <div>{breakLine(event.description)}</div>
        </div>
      </div>
    </div>
  );
};

export default EventDetailScreen;



// WEBPACK FOOTER //
// ./src/screens/MainPage/EventDetailScreen.js